import axios, {AxiosError, AxiosResponse, CancelToken} from 'axios';
import Notifier from '../helpers/Notifier';
import {REQUEST_CANCELED} from "../helpers/Message";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

/**
 * APIs class.
 */
export default class GenericApi {
    static headers: object | null = null;
    static cancelToken: CancelToken | null = null;

    /**
     * Get something from API.
     *
     * @param url
     * @param query
     */
    public static async get<T>(url: string, query: T | null = null): Promise<any> {
        let options: any = {params: query};
        const title = 'Une erreur est survenue';

        if (null !== this.headers) {
            options.headers = this.headers;
        }

        if (null !== this.cancelToken) {
            options.cancelToken = this.cancelToken;
        }

        // Call API baseUrl with GET method on /url
        return api.get(url, options)
            .then((response: AxiosResponse) => {
                return response.data;
            })
            .catch((error: any) => {
                if (!error || (error && REQUEST_CANCELED !== error.message)) {
                    Notifier.createNotification(title, `Impossible de communiquer avec l'API`, 'danger', 10000);
                }

                return null;
            });
    }

    /**
     * Post something on API.
     *
     * @param url
     * @param body
     */
    public static async post<T>(url: string, body: T | null = null): Promise<any> {
        let options = undefined;

        if (null !== this.headers) {
            options = this.headers;
        }

        // Call API baseUrl with POST method on /url
        return api.post(url, body, options)
            .then((response: AxiosResponse) => {
                return response.data;
            })
            .catch((error: Error | AxiosError) => {
                this.notifyFail(error);
                return null;
            });
    }

    /**
     * Define what to do after a fail API call with a body
     *
     * @param error
     */
    protected static notifyFail(error: any) {
        //We create a danger notification for each errors from our API response
        if (403 === error.response.status) {
            Notifier.notifyApiError({origin: 'Role', message: 'Vous n\'avez pas les droits suffisants.'});
        } else if (typeof error.response.data.errors !== 'undefined') {
            Notifier.notifyApiErrors(error.response.data.errors);
        } else {
            Notifier.notifyApiError(error.response.data);
        }
    }
};
